import classNames from 'classnames';
import { FC, useMemo } from 'react';
import { twMerge } from 'tailwind-merge';
import Swiper, { SwiperSlide } from '@/components/common/Swiper';

type IProps = {
  classname?: string;
  data: {
    label_key: string;
    label_name: string;
    label_color: string;
    label_font_color: string;
    label_position: string;
  };
};

const RewardsDealTag: FC<IProps> = ({ data, classname }) => {
  const labelNames = useMemo(() => {
    if (!data?.label_name) return [];
    return data?.label_name?.split('\n');
  }, [JSON.stringify(data?.label_name)]);

  return (
    <div
      className={twMerge(
        classNames(
          'absolute left-[50%] top-[1px] -translate-y-[calc(50%-8px)] -translate-x-[calc(50%+6px)] scale-50',
          classname
        )
      )}>
      <div
        className={twMerge(
          'p-2 py-1 h-5 !leading-5 enki-body-base-strong',
          'border-[4px] border-solid border-surface-100-bg rounded-200',
          labelNames?.length > 1 ? 'whitespace-nowrap overflow-hidden' : ''
        )}
        style={{ backgroundColor: data?.label_color, color: data?.label_font_color }}>
        {labelNames?.length > 1 ? (
          <Swiper
            autoplay={{ delay: 200 }}
            speed={2000}
            loop={true}
            direction="vertical"
            className="!h-full !w-auto !text-center">
            {labelNames?.map((item, i) => {
              return (
                <SwiperSlide key={i} className="!h-full !w-auto min-w-[56px]">
                  {item}
                </SwiperSlide>
              );
            })}
          </Swiper>
        ) : (
          <div
            className="overflow-hidden text-ellipsis whitespace-nowrap"
            style={{ maxWidth: '120px' }}
            dangerouslySetInnerHTML={{ __html: labelNames?.[0] }}></div>
        )}
      </div>
    </div>
  );
};

export default RewardsDealTag;
